import React from "react";
import PropTypes from "prop-types";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import Grid from "@mui/material/Grid";

const UserStatusGrid = ({handleFieldChange, user, buttonParam, adminEditor}) => {

  return (
    <Grid item xs={12} container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <ToggleButtonGroup
          value={user.commissioned?.value}
          exclusive
          onChange={(event, newStatus) => handleFieldChange("commissioned", newStatus)}
          fullWidth
          //disabled={!adminEditor}
          disabled
        >
          <ToggleButton value={buttonParam.value} color={buttonParam.value === "YES" && adminEditor ? "secondary" : "standard"}>
            {user.commissioned?.name}
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
};

UserStatusGrid.propTypes = {
  handleFieldChange: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  buttonParam: PropTypes.object.isRequired,
  adminEditor: PropTypes.bool
};

export default UserStatusGrid;
